module.exports = __webpack_public_path__ + "static/img/celoscope-22.8e92813.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-22.jpg
// module id = Dq9V
// module chunks = 52